'use client';

import { Sidebar } from '@/components/Sidebar/Sidebar';

import type { WorkbenchMode } from './types';
import type { CommentUserInfo, DevicePreset, Pin } from '@/types/feedback';

/** Sidebar `w-72` plus the panel's right padding. */
export const SIDEBAR_PANEL_WIDTH = 288 + 20;

interface WorkbenchSidebarPanelProps {
  visible: boolean;
  pins: Pin[];
  device: DevicePreset;
  allDevices: boolean;
  mode: WorkbenchMode;
  commenterInfoMap?: Record<string, CommentUserInfo>;
  selectedPinId: string | null;
  onPinClick: (id: string) => void;
  onReopenPin: (id: string) => void;
  onClose: () => void;
}

export function WorkbenchSidebarPanel({
  visible,
  pins,
  device,
  allDevices,
  mode,
  commenterInfoMap,
  selectedPinId,
  onPinClick,
  onReopenPin,
  onClose,
}: WorkbenchSidebarPanelProps) {
  if (!visible) return null;

  return (
    <div
      className="absolute right-0 top-12 bottom-0 z-10 flex items-stretch"
      style={{ padding: '20px 20px 20px 0' }}
      onClick={(e) => e.stopPropagation()}
    >
      <Sidebar
        pins={pins}
        device={device}
        allDevices={allDevices}
        mode={mode}
        commenterInfoMap={commenterInfoMap}
        selectedPinId={selectedPinId}
        onPinClick={onPinClick}
        onReopenPin={onReopenPin}
        onClose={onClose}
      />
    </div>
  );
}
